import React from 'react';
import langConf from "../js/lang";
import shelegApi from '../api/shelegAPI';

class ValidationCode extends React.Component {

    handleClick = async (event) => {
        let lang = this.props.language;
        if (this.props.validateCode(document.querySelector('#validationCode').value))
            this.props.changeScreen('customerDetails');
        else if (window.confirm(langConf[lang].wrongCode)){
                await this.props.generateValidationCode();
                const pkg = {
                    sessionId: this.props.sessionId, 
                    recipientNo: this.props.mobile,
                    senderNo: '+16694000616',
                    msgText: `${langConf[lang].codeWAMessage} ${this.props.validationCode}`,
                };
                //console.log('pkg: ', pkg);
                const response = await shelegApi.post('/SendWAMsg/', pkg);
                //console.log('response: ', response);
                if (response.statusText === "OK"){
                    this.props.changeScreen('validationCode');
                }
        } 
    };

    render() {
        let lang = this.props.language;
        return (
            <div className='col-xl-12'>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-2 col-0"></div>
                <div className='form-group col-xl-4 col-lg-4 col-md-4 col-sm-8 col-12'>
                <div className="alert alert-info" role="alert" style={lang === 'hebrew' ? {direction: 'rtl'} : {direction: 'ltr'}}>{`${langConf[lang].validationCodeInWA} `}<i className={`fab fa-whatsapp`}></i></div>
                    <label htmlFor='validationCode'>{langConf[lang].validationCode}</label>
                    <input type='number' id='validationCode' className='form-control'/>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-2 col-0"></div>
                <div className="col-xl-12">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-2 col-0"></div>
                <div className='form-group col-xl-4 col-lg-4 col-md-4 col-sm-8 col-12'>
                        <input type='button' className='btn btn-success btn-lg btn-block' value={langConf[lang].validate} onClick={this.handleClick} />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-2 col-0"></div>
                </div>
            </div>
        );
    }
}

export default ValidationCode;